export default {
  panel: {
    title: 'Un problème ? Une question ?',
    description: "On est là pour t'aider !",
    button: 'Contacter le support',
    close: 'Pas pour le moment',
  },
};
